import React, { useEffect,  useRef, useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import { format } from "date-fns";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";
import FASTable from "../../../../../components/Tables/FASTable";
import FASChart from "../../../../../components/Charts/FASChart";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import {
  SaleBook,
  SaleParty,
  SalesPartyMonthItem,
  SalesPartyMonthItemQuarter,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Sale/SaleSlice";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const PartyWiseQuater = () => {
  const dispatch = useDispatch();

  const { Colourdata, mainFilterData, DataMain } = useSelector(
    (state) => state.ClientLogin,
  );
  const { SaleBookdata, SalePartydata, SalesPartyMonthItemQuarterData } =
    useSelector((state) => state.SaleSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");
  const FinancialYear = Cookies.get("FinancialYear");
  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(SaleBook({ Firm, Year: YearId }));
    dispatch(SaleParty({ Firm, Year: YearId }));
    dispatch(FilterMain({ Firm, Year: YearId }));
    // dispatch(SalesPartyMonthItem({ Firm, Year: YearId }));
    dispatch(
      SalesPartyMonthItemQuarter({
        Firm,
        Year: YearId,
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      }),
    );
  }, [dispatch, Firm, YearId]);

  const [filters, setFilters] = useState({
    month: [],
    saleBook: [],
    productionGroup: [],
    saleParty: [],
  });

  const [search, setSearch] = useState({
    month: "",
    saleBook: "",
    productionGroup: "",
    saleParty: "",
  });
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedSaleBook, setSelectedSaleBook] = useState("");
  const [selectedSaleBookId, setSelectedSaleBookId] = useState([]);

  const [selectedProductionGroup, setSelectedProductionGroup] = useState("");
  const [selectedProductionGroupId, setSelectedProductionGroupId] = useState(
    [],
  );

  const [selectedSaleParty, setSelectedSaleParty] = useState("");
  const [selectedSalePartyId, setSelectedSalePartyId] = useState([]);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.month,
    })) || [];
  const saleBookList =
    SaleBookdata?.BookName?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];
  const salePartyList =
    SalePartydata?.BookName?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const productionList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const getRowsdata = () => {
    return (
      SalesPartyMonthItemQuarterData?.Dtls?.map((el, index) => ({
        // srNumber: index + 1,
        ...el,
      })) || []
    );
  };

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "NetAmount",
      key: "NetAmount",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-1 Amount",
      key: "Qua1Amount",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-1 Qunatity",
      key: "Qua1Quality",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-1 Per Piece Price",
      key: "Qua1Price",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-2 Amount",
      key: "Qua2Amount",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-2 Qunatity",
      key: "Qua2Quality",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-2 Per Piece Price",
      key: "Qua2Price",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-3 Amount",
      key: "Qua3Amount",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-3 Qunatity",
      key: "Qua3Quality",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-3 Per Piece Price",
      key: "Qua3Price",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-4 Amount",
      key: "Qua4Amount",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-4 Qunatity",
      key: "Qua4Quality",
      align: "right",
      format: "true",
    },
    {
      label: "Qua-4 Per Piece Price",
      key: "Qua4Price",
      align: "right",
      format: "true",
    },
  ];

  const [showFilter, setShowFilter] = useState(false);

  const applyFilter = async () => {
    setIsFilterLoading(true);

    const payload = {
      Firm,
      Year: YearId,
      selectePdGroupdIds: filters.productionGroup?.toString() || "",
      selecteBookdIds: filters.saleBook?.toString() || "",
      selectSalepartyIds: filters.saleParty?.toString() || "",
      selectmonthname: filters.month?.toString() || "",
      selectestartdate: safeFormat(startDate),
      selectenddate: safeFormat(endDate),
    };

    try {
      await Promise.all([
        // dispatch(SalesPartyMonthItem(payload)),
        dispatch(SalesPartyMonthItemQuarter(payload)),
      ]);
    } finally {
      setIsFilterLoading(false);
    }
  };
  const applyFilter1 = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        selecteBookdIds: selectedSaleBookId?.toString() || "",
        selectePdGroupdIds: selectedProductionGroupId?.toString() || "",
        selectSalepartyIds: selectedSalePartyId?.toString() || "",
        selectmonthname: selectedMonthId?.toString() || "",
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      // await dispatch(SalesPartyMonthItem(payload));

      await dispatch(SalesPartyMonthItemQuarter(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };
  const toggleItem = (type, item) => {
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].includes(item.value) ? [] : [item.value],
    }));
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${
      isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
    }`,
    borderLeft: `6px solid ${
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
    }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };
  const isLoading =
    !SaleBookdata ||
    !SalePartydata ||
    !SalesPartyMonthItemQuarterData ||
    !mainFilterData ||
    isFilterLoading;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
@media (min-width: 1200px) {
  .filter-col {
    flex: 0 0 20% !important;
    max-width: 20% !important;
  }
}
      @media (min-width: 1200px) {
    .quarter-box {
      flex: 0 0 20% !important;
      max-width: 20% !important;
    }
  }
  @media (max-width: 1199px) {
    .partywise-quarter-box {
      flex: 0 0 50% !important;
      max-width: 50% !important;
    }
  }

  @media (max-width: 575px) {
    .partywise-quarter-box {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
`}</style>
      {/* MOBILE FILTER BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* Month */}
            <FASFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            {/* Sale Books */}
            <FASFilterBox
              title="Sale Books"
              items={saleBookList}
              search={search.saleBook}
              setSearch={(val) => handleSearch("saleBook", val)}
              selectedItems={filters.saleBook}
              toggleItem={(item) => toggleItem("saleBook", item)}
              selectAll={() => selectAll("saleBook", saleBookList)}
            />

            {/* Production Groups */}
            <FASFilterBox
              title="Production Groups"
              items={productionList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionList)}
            />

            {/* Sale Party */}
            <FASFilterBox
              title="Sale Party"
              items={salePartyList}
              search={search.saleParty}
              setSearch={(val) => handleSearch("saleParty", val)}
              selectedItems={filters.saleParty}
              toggleItem={(item) => toggleItem("saleParty", item)}
              selectAll={() => selectAll("saleParty", salePartyList)}
            />

            {/* Apply Button */}
            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        {/* RIGHT CONTENT */}
        <Col xl={12} lg={12} md={12}>
          <Row className="g-3">
            {/* BOX 1 */}
            <Col xl={2} lg={6} md={6} sm={6} xs={12} className="quarter-box">
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {formatIndianRupee(
                    SalesPartyMonthItemQuarterData?.Sum[0]?.Qua1Amount,
                  )}
                </h4>
                <h6 style={titleStyle}>Quarter 1 Amount</h6>
              </div>
            </Col>

            {/* BOX 2 */}
            <Col xl={2} lg={6} md={6} sm={6} xs={12} className="quarter-box">
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {formatIndianRupee(
                    SalesPartyMonthItemQuarterData?.Sum[0]?.Qua2Amount,
                  )}
                </h4>
                <h6 style={titleStyle}>Quarter 2 Amount</h6>
              </div>
            </Col>

            {/* BOX 3 */}
            <Col xl={2} lg={6} md={6} sm={6} xs={12} className="quarter-box">
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {" "}
                  {formatIndianRupee(
                    SalesPartyMonthItemQuarterData?.Sum[0]?.Qua3Amount,
                  )}
                </h4>
                <h6 style={titleStyle}> Quarter 3 Amount</h6>
              </div>
            </Col>

            {/* BOX 4 */}
            <Col xl={2} lg={6} md={6} sm={6} xs={12} className="quarter-box">
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {formatIndianRupee(
                    SalesPartyMonthItemQuarterData?.Sum[0]?.Qua4Amount,
                  )}
                </h4>
                <h6 style={titleStyle}>Quarter 4 Amount</h6>
              </div>
            </Col>

            {/* BOX 5 */}
            <Col xl={2} lg={6} md={6} sm={6} xs={12} className="quarter-box">
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {formatIndianRupee(
                    SalesPartyMonthItemQuarterData?.Sum[0]?.NetAmount,
                  )}
                </h4>
                <h6 style={titleStyle}>Net Amount</h6>
              </div>
            </Col>
          </Row>
          <div
            className="d-none d-lg-block"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
              }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3">
              {/* Row 1 - 2 filters */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Month"
                  placeholder="Select Month"
                  data={monthList}
                  selectedValue={selectedMonth}
                  setSelectedValue={setSelectedMonth}
                  selectedId={selectedMonthId}
                  setSelectedId={setSelectedMonthId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Books"
                  placeholder="Select Sale Book"
                  data={saleBookList}
                  selectedValue={selectedSaleBook}
                  setSelectedValue={setSelectedSaleBook}
                  selectedId={selectedSaleBookId}
                  setSelectedId={setSelectedSaleBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Row 2 - 2 filters */}
              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Production Groups"
                  placeholder="Select Production Group"
                  data={productionList}
                  selectedValue={selectedProductionGroup}
                  setSelectedValue={setSelectedProductionGroup}
                  selectedId={selectedProductionGroupId}
                  setSelectedId={setSelectedProductionGroupId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              <Col xl={6} lg={6} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Party"
                  placeholder="Select Sale Party"
                  data={salePartyList}
                  selectedValue={selectedSaleParty}
                  setSelectedValue={setSelectedSaleParty}
                  selectedId={selectedSalePartyId}
                  setSelectedId={setSelectedSalePartyId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Row 3 - 1 button full width */}
              <Col xl={12} lg={12} md={12} sm={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                  }}
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
          {/* 🔹 CHART */}

          <Row className="g-3">
            <Col xl={12} lg={12} md={12}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "12px",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    QUARTERWISE SALES AMOUNT
                  </h2>
                </div>

                <FASChart
                  data={[
                    {
                      month: "Q1",
                      value: Number(
                        SalesPartyMonthItemQuarterData?.Sum?.[0]?.Qua1Amount ||
                          0,
                      ),
                    },
                    {
                      month: "Q2",
                      value: Number(
                        SalesPartyMonthItemQuarterData?.Sum?.[0]?.Qua2Amount ||
                          0,
                      ),
                    },
                    {
                      month: "Q3",
                      value: Number(
                        SalesPartyMonthItemQuarterData?.Sum?.[0]?.Qua3Amount ||
                          0,
                      ),
                    },
                    {
                      month: "Q4",
                      value: Number(
                        SalesPartyMonthItemQuarterData?.Sum?.[0]?.Qua4Amount ||
                          0,
                      ),
                    },
                    {
                      month: "Net",
                      value: Number(
                        SalesPartyMonthItemQuarterData?.Sum?.[0]?.NetAmount ||
                          0,
                      ),
                    },
                  ]}
                  labelKey="month"
                  valueKey="value"
                />
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: "20px" }}>
            <Col xs={12}>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour4,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    padding: "14px",
                  }}
                >
                  <h5
                    style={{
                      fontSize: "18px",
                      margin: 0,
                      letterSpacing: "1px",
                      fontWeight: "600",
                    }}
                  >
                    PARTYWISE MONTLY SALE AMOUNT
                  </h5>
                </div>

                <FASTable columns={getColumns} data={getRowsdata()} />
              </div>
            </Col>
          </div>
        </Col>
      </Row>
    </div>
  );
};
